/**
 * @ngdoc generalMeetingListController
 * @description This controller is used for general meeting module.
 * @requires generalMeetingHomeModule where there is a service call to
 *           sharePlanHolderGMList
 * @requires $scope and $log
 */
import { translateMeetingType } from '@/lib/meetingTranslationHelper';

angular
  .module('generalMeetingHomeModule')
  .controller('generalMeetingListController', [
    '$scope',
    '$log',
    '$state',
    'shareHolderService',
    '$filter',
    function (
      $scope,
      $log,
      $state,
      shareHolderService,
      $filter,
    ) {
      $scope.onLoadSpinner = true;
      shareHolderService
        .getSHGeneralMeetings()
        .query()
        .$promise.then(
          function (data) {
            $scope.gmList = [];
            $scope.generalMeetinglist = data;
            angular.forEach($scope.generalMeetinglist, function (item) {
              if (item.status === 'L') {
                $scope.gmList.push(item);
              }
            });
            $scope.onLoadSpinner = false;
          },
          function (error) {
            $scope.onLoadSpinner = false;
            return error;
          }
        );
      $scope.goGMDetails = function (
        meetingId,
        meetingName,
        issuerId,
        issuerName,
        generalMeetingDateStr,
        status,
        intermediaryDeadlineDate,
        intermediaryDeadlineDateStr
      ) {
        $state.go('generalMeetings', {
          selectedIndex: 0,
          meetingId: meetingId,
          issuerId: issuerId,
          issuerName: issuerName,
          status: status,
          intermediaryDateTimeStamp: intermediaryDeadlineDate,
          intermediaryDate: intermediaryDeadlineDateStr,
          breadCrumbDetails: [],
        });
      };

      $scope.translateMeetingType = function (meetingTypeStr) {
        return translateMeetingType($filter, meetingTypeStr);
      };

    },
  ]);
